export default __webpack_public_path__ + "static/media/Anastasinis.64a7330e.jpg";